import InfoNotificationAlert from "../entities/InfoNotificationAlert";
import { AdminSocketRepository } from "../repositories/AdminSocketRepository";

export class OnNotificationAlert {
	constructor(private repository: AdminSocketRepository) {}

	execute(callback: (data: InfoNotificationAlert) => void): void {
		return this.repository.onNotificationAlert(callback);
	}
}
